import { render, staticRenderFns } from "./Cityselect.vue?vue&type=template&id=48705e23&scoped=true&"
import script from "./Cityselect.vue?vue&type=script&lang=js&"
export * from "./Cityselect.vue?vue&type=script&lang=js&"
import style0 from "./Cityselect.vue?vue&type=style&index=0&id=48705e23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48705e23",
  null
  
)

export default component.exports